<template>
  <stacked-bar-chart
    class="charts__chart"
    :chart-data="stackedChartData"
    :numberOfResponses="numberOfResponses" />
</template>

<script>
import StackedBarChart from '../charts/StackedBarChart';

export default {
  name: 'analysis-multiple-response',

  props: ['field', 'numberOfResponses'],

  components: { StackedBarChart },

  computed: {
    stackedChartData() {
      const datasets = [];
      const colors = ['#ffffff', '#f1d7d6', '#ebc3c1', '#e1a7a3', '#d58580', '#ca605b', '#be3f38', '#b4221a'];

      [...Array(8)].forEach((label, index) => {
        const data = () => {
          if (index === 0) {
            return this.field.values.map(option => option.noResponsesPercentage);
          }
          return this.field.values.map(option => option.percentage[index - 1]);
        };

        datasets.push({
          label: index === 0 ? 'No Response' : index,
          backgroundColor: colors[index],
          numberOfResponses: this.numberOfResponses,
          data: data(),
        });
      });

      return {
        labels: this.field.values.map(option => option.title),
        datasets,
      };
    },
  },
};
</script>